import React from "react";
import { HiCurrencyDollar } from "react-icons/hi2";
import { FaTelegramPlane } from "react-icons/fa";
import { FaUserAlt } from "react-icons/fa";
import { FaBriefcase } from "react-icons/fa";
import { TiTick } from "react-icons/ti";
import { IoClose } from "react-icons/io5";
import { RiChatPrivateLine } from "react-icons/ri";
import { RiUserSharedLine } from "react-icons/ri";
import RatingStars from "./RatingStars";
import { useLocation, useNavigate } from "react-router-dom";

const TransferSingleResult = (
  
  {
  imgUrl,
  title,
  vehicleType,
  model,
  lugg,
  make,
  pax,
  responcetype,
  price,
  meet_greet,
  trasnfer_type,
  water_bottle,
  handlePayLater,
  handlePayNow
}) => {
 
  return (
    <div className="flex flex-col md:flex-row relative items-center mb-9">
      <div className="w-full md:w-2/5 border flex justify-center items-center xl:w-1/3 h-[250px] rounded-xl">
        <img className="object-cotain w-[70%] object-center" src={imgUrl} alt="img" />
      </div>
      <div className="w-full md:w-[calc(60%+24px)] xl:w-[calc(66.66667%+24px)] border rounded-2xl md:rounded-lg md:-ms-6 -mt-6 md:-mt-0 bg-white px-3 md:px-4 py-5 flex-none">
        <div className="sm:flex justify-between">
          <div>
            <h1 className="text-lg font-semibold mb-1">{title}</h1>
            {/* <div className="flex items-center mb-1">
              <RatingStars star={star} />
              <p className="ms-1 font-medium">({star})</p>
            </div> */} 

           
            <div className="flex flex-wrap gap-2 mt-4">
              <div className="border border-primary text-primary p-1 rounded font-semibold uppercase">{vehicleType}</div>
            </div>
            <br></br>

            <div className="flex flex-wrap gap-2 mt-4">
            <div className="flex items-center  gap-3">
              <div className="flex items-center justify-center gap-2">
                <div className="text-primary">
                  <FaUserAlt />
                </div>
                <p className="font-medium text-secondary">{pax}</p>
              </div>
              <div className="flex items-center justify-center gap-2">
                <div className="text-primary">
                  <FaBriefcase />
                </div>
                <p className="font-medium text-secondary">{lugg}</p>
              </div>
            </div>
            <div className=" text-primary p-1 rounded font-semibold uppercase">
              Vehicle Type:&nbsp;<span style={{color: "black" ,fontSize:"14px" }}>{make}{model}</span>&nbsp;&nbsp;
              {trasnfer_type === 'private' && (<>Transfer Type:&nbsp;<span style={{ color: "black", fontSize:"14px" }}>{trasnfer_type}</span></>)}
              {trasnfer_type === 'shared' && (<>Transfer Type:&nbsp;<span style={{ color: "black" ,fontSize:"14px"  }}>{trasnfer_type}</span></>)}
                
              </div>
            
            </div>
           
            {responcetype === 'book_now' && ( 
               <div className="flex flex-wrap gap-2 mt-4">
                 {meet_greet === 'yes' && (
                <div className="text-primary p-1 rounded font-semibold uppercase flex items-center gap-2">
                <span style={{color: "black"}}>Meet Greet:</span>
                  <TiTick  style={{ fontSize: "1.6rem"}} className="text-primary text-lg" />
                </div>
                 )}
                {/* <div className="text-primary p-1 rounded font-semibold uppercase flex items-center gap-2">
                <span style={{color: "black"}}>Transfer Type:</span>
                  {trasnfer_type === 'private' && <RiChatPrivateLine  style={{ fontSize: "1.6rem"}} className="text-primary text-lg" />}
                  {trasnfer_type !== 'private' && <RiUserSharedLine  style={{ fontSize: "1.6rem"}} className="text-primary text-lg" />}
                </div> */}
                {water_bottle === 'yes' && (
                  <div className="text-primary p-1 rounded font-semibold uppercase flex items-center gap-2">
                    <span style={{ color: "black" }}>Water Bottle:</span>
                    <TiTick style={{ fontSize: "1.6rem" }} className="text-primary text-lg" />
                  </div>
                )}
                
           </div>
           
            )}
          </div>
          {responcetype === 'book_now' && (
            <div className="flex sm:block justify-between">
              <div className="flex items-center gap-1">
                <HiCurrencyDollar color="#63AB45" />
                <p className="font-medium">Starting from</p>
              </div>
              <p className="text-xl font-bold justify-end" style={{textAlign: "right"}}>AU$&nbsp;{price}</p>
            </div>
          )}
        </div>
        <div className="flex gap-3 items-center justify-end mt-4">
        {responcetype === 'book_now' && (
          <button
            onClick={(e)=> handlePayLater(e,'pay_later')}
            className="flex mt-3 xl:mt-0 w-max items-center border rounded-full bg-white text-primary font-medium flex-none"
          >
            <span className="px-4 py-3">Reserve Now</span>
            <span className="w-9 h-9 bg-primary text-secondary flex justify-center items-center rounded-full me-1">
              <FaTelegramPlane color={"#fff"} />
            </span>
          </button>
          )}
          <button
            onClick={(e) => handlePayNow(e)}
            className="flex mt-3 xl:mt-0 w-max items-center border rounded-full bg-primary text-white font-medium flex-none"
          >
            <span className="px-4 py-3">
              {responcetype === 'book_now' ? 'Book now' : 'Get Quote'}
            </span>
            <span className="w-9 h-9 bg-white text-secondary flex justify-center items-center rounded-full me-1">
              <FaTelegramPlane color={"#63AB45"} />
            </span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default TransferSingleResult;
